<template>
  <a class="c-hashtag" :href="href">
    <span class="c-hashtag__heart">
      <f-heart
        :handle="handle"
        :id="handle"
        :is-favourite="isFavourite"
        size="large"
        type="hashtag"
        @heart-changed="isFavourite = $event"
      ></f-heart>
    </span>
    {{ text }}
  </a>
</template>

<script>
import { favouriteHashtagHandles } from '~/js/templates/index/helpers'
import FHeart from '~/js/components/heart'
export default {
  name: 'ComponentHashtag',
  components: {
    FHeart,
  },
  props: {
    text: { type: String, default: '' },
  },
  data() {
    return {
      isFavourite: false,
    }
  },
  computed: {
    handle() {
      return this.text.replace(/^\#/, '')
    },
    href() {
      return `/search?type=product&q=${encodeURIComponent(this.text)}`
    },
  },
  created() {
    this.isFavourite = favouriteHashtagHandles.includes(this.handle)
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:color';
@use '~/scss/generic/variables';
@use '~/scss/generic/mixins';

.c-hashtag {
  font-weight: 600;
  display: flex;
  align-items: center;

  @include mixins.screen-desktop {
    padding: 4px 8px;
    border-radius: 8px;
    transition: background-color 0.3s;
  }

  &:hover {
    @include mixins.screen-desktop {
      background-color: color.adjust(variables.$color-pink, $lightness: 4%);
    }
  }

  &__heart {
    margin-right: 8px;
    line-height: 1;
  }
}
</style>
